import React from "react";
import { makeStyles } from "@civicplus/preamble-ui/lib/Utilities/ThemeHelper";
import Grid from "@civicplus/preamble-ui/lib/Grid";
import EventFilter from "./EventFilter";
import EventSidebar from "./EventSidebar";
import EventList from "./EventList";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexGrow: 1,
    padding: theme.spacing(2),
    boxSizing: "border-box",
    width: "100%",
    container: "mainContainer / inline-size",
  },
  asideSection: {
    flexGrow: 1,
    width: "100%",
    maxWidth: 300,
    "@container mainContainer (width > 800px)": {
      maxWidth: 350,
    },
    [theme.breakpoints.down("lg")]: {
      display: "none",
    },
  },
  mainSection: {
    flex: 1,
    display: "flex",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  mainSectionGrid: {
    flexWrap: "nowrap",
    flexDirection: "column",
    flex: "1 1 auto",
  },
  eventsContainer: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    minHeight: theme.spacing(40),
  },
  eventFilterGrid: {
    flexShrink: 1,
    flexBasis: 0,
  },
  gridWrapper: {
    flex: "1 1 auto",
  },
}));

const EventListWrapper: React.FC = () => {
  const classes = useStyles();
  const Root = process.env.REACT_APP_EMBED ? "section" : "main";
  return (
    <Root className={classes.root}>
      <Grid
        className={classes.gridWrapper}
        container={true}
        spacing={2}
        xs={12}
        data-testid="eventList"
      >
        <Grid
          className={classes.asideSection}
          component="aside"
          aria-label="Date Navigation and Filtering"
        >
          <EventSidebar />
        </Grid>

        <Grid className={classes.mainSection} xs={12} component="section">
          <Grid
            className={classes.mainSectionGrid}
            container={true}
            spacing={2}
            xs={12}
          >
            <Grid className={classes.eventFilterGrid} xs={12}>
              <EventFilter />
            </Grid>
            <Grid className={classes.eventsContainer} xs={12}>
              <EventList />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Root>
  );
};

export default EventListWrapper;
